"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["Pending"] = 0] = "Pending";
    PaymentStatus[PaymentStatus["Fulfilled"] = 1] = "Fulfilled";
    PaymentStatus[PaymentStatus["ChargedBack"] = 2] = "ChargedBack";
    PaymentStatus[PaymentStatus["Failed"] = 3] = "Failed";
    PaymentStatus[PaymentStatus["PreAuthorized"] = 4] = "PreAuthorized";
    PaymentStatus[PaymentStatus["Uncaptured"] = 5] = "Uncaptured";
    PaymentStatus[PaymentStatus["Cancelled"] = 6] = "Cancelled";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
//# sourceMappingURL=PaymentStatus.js.map